import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { Home, History, User } from "lucide-react";
import BottomNav from "@/components/BottomNav";
import { api } from "@/lib/api";

export default function DriverShell() {
  const [incoming, setIncoming] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get("/driver/incoming");
        setIncoming(data ? 1 : 0);
      } catch (e) {
        // ignore
      }
    };
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  const items = [
    { to: "/driver", icon: Home, label: "Drive", testId: "tab-driver-home", end: true, badge: incoming },
    { to: "/driver/history", icon: History, label: "Trips", testId: "tab-driver-history" },
    { to: "/driver/profile", icon: User, label: "Profile", testId: "tab-driver-profile" },
  ];
  return (
    <div className="mobile-shell pb-24" data-testid="driver-shell">
      <Outlet />
      <BottomNav items={items} />
    </div>
  );
}
